import Routes from '../routes.mjs';

interface Route {
  name: string;
  page: string;
}

const replacePageName = (routePage: string) => {
  const routesMatchingPageName = (
    Routes as unknown as { routes: Route[] }
  ).routes
    .filter(({ page }) => page === routePage);

  if (routesMatchingPageName.length === 0) {
    return routePage;
  }

  return routesMatchingPageName.length === 1
    ? routesMatchingPageName[0].name
    : routesMatchingPageName[0].name.replace(/\..+$/, '');
};

export default replacePageName;
